import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { NgIf } from '@angular/common';
import { GoverningJurisdictionTypeId } from '../../../../models/enum/shared/governing-jurisdiction-type-id';
import { GoverningJurisdictionNamePipe } from '../../../../views/shared/pipes/governing-jurisdiction-name.pipe';

@Component({
  selector: 'app-final-location-jurisdiction-title',
  standalone: true,
  imports: [NgIf, GoverningJurisdictionNamePipe],
  templateUrl: './final-location-jurisdiction-title.component.html',
  styleUrls: ['./final-location-jurisdiction-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FinalLocationJurisdictionTitleComponent implements OnChanges {
  /** The account's own jurisdiction. */
  @Input({ required: true }) jurisdictionId!: GoverningJurisdictionTypeId;
  /** The jurisdiction in use; null means Default(s). */
  @Input({ required: true }) finalLocationId!: GoverningJurisdictionTypeId | null;

  public titleJurisdictionId!: GoverningJurisdictionTypeId;
  public originalJurisdictionId: GoverningJurisdictionTypeId | null = null;

  public ngOnChanges(): void {
    const isOverridden = this.finalLocationId !== null && this.finalLocationId !== this.jurisdictionId;
    this.titleJurisdictionId = this.finalLocationId ?? this.jurisdictionId;
    this.originalJurisdictionId = isOverridden ? this.jurisdictionId : null;
  }
}
